import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavBar, DataTables, BreadCumb, TimeOut } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';
import $ from 'jquery';
let apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "Código", value: true },
    { title: "Nombre", value: true },
    { title: "Email", value: true },
];

class MVentasAdminUsersView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            headers: headersDataTable,
            listUsers: [],
            totalRows: 0,
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            detailsData: {},
            showMVentasAdminModal: false,
            modules: [],
        }
    }

    componentDidMount = async () => {
        this.searchUsers();
        this.getModules();
    }
    getModules = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        enableSpinner(true);
        const modules = await apiClient.mVentasGetModules();
        enableSpinner(false);

        if (modules.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                modules: modules?.data ?? [],
            })
        } else {
            showAlert({ type: 'error', message: modules.message })
        }
    }
    setShowMVentasModal = value => {
        this.setState({
            showMVentasAdminModal: value
        })
    }
    openDetails = async (user) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const data = {
            table: 'OHEM',
            search: user.empID || ''
        }
        enableSpinner(true);
        const details = await apiClient.mVentasDetails(data);

        enableSpinner(false);
        if (details.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                detailsData: details?.data ?? {},
                showMVentasAdminModal: true
            })
            $('#MVentasAdminUsersModal').modal('show');
        } else {
            showAlert({ type: 'error', message: details.message })
        }
    }
    searchUsers = async (search) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const data = {
            table: 'OHEM'
        }
        enableSpinner(true);
        const listUsers = await apiClient.mVentasListData(data);
        enableSpinner(false);

        if (listUsers.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                listUsers: listUsers?.data ?? [],
                totalRows: listUsers?.data?.length ?? 0
            })
        } else {
            showAlert({ type: 'error', message: listUsers.message })
        }

    }
    setDetailsData = newData => {
        this.setState({
            detailsData: newData
        })
    }
    saveUser = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { detailsData } = this.state;
        const data = {
            table: 'OHEM',
            model: detailsData,
        }
        enableSpinner(true);
        const saveUserResponse = await apiClient.mVentasSaveUser(data);
        enableSpinner(false);

        if (saveUserResponse.status === SERVICE_RESPONSE.SUCCESS) {
            $('#MVentasAdminUsersModal').modal('hide');
            this.setState({
                detailsData: {},
                showMVentasAdminModal: false
            })
            showAlert({ type: 'success', message: saveUserResponse.message })
        } else {
            showAlert({ type: 'error', message: saveUserResponse.message })
        }
    }



    render() {
        const { headers, _user, totalRows, listUsers, detailsData, showMVentasAdminModal, modules } = this.state;

        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'ADMINISTRACIÓN DE USUARIOS'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <a href=" " id="headmVAdminUser" className="text-muted">
                            &nbsp;ADMINISTRACIÓN DE USUARIOS
                        </a>
                    </h2>
                    <DataTables
                        headers={headers}
                        view={"adminUsersMVentas"}
                        data={listUsers}
                        search={this.searchUsers}
                        totalRows={totalRows}
                        openDetails={this.openDetails}
                        detailsData={detailsData}
                        setShowMVentasModal={this.setShowMVentasModal}
                        showMVentasAdminModal={showMVentasAdminModal}
                        modules={modules}
                        setDetailsData={this.setDetailsData}
                        saveUser={this.saveUser}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MVentasAdminUsersView);
